import { AspectRatioDimensions, AspectRatioName } from 'types';

export const TEMPLATE_DIMENSIONS_BY_ASPECT_RATIO: Record<
  AspectRatioName,
  AspectRatioDimensions
> = {
  landscape: { width: 1920, height: 1080 },
  square: { width: 1080, height: 1080 },
  portrait: { width: 1080, height: 1920 },
};
